export default function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };

      return !!getIn(nonNullGetFormState(state), form + ".submitFailed");
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ../redux-form/es/selectors/hasSubmitFailed.js
// module id = 1234
// module chunks = 22